import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Facebook, MessageCircle } from "lucide-react";
import { COMPANY, NAV_LINKS, whatsappLink } from "@/data/site";

const FooterNavColumn = ({ title, links }) => (
  <div>
    <h4 className="font-display text-[18px] tracking-wider mb-4 text-[#E8721C]">{title}</h4>
    <ul className="space-y-2 text-sm">
      {links.map((l) => (
        <li key={l.to}><Link to={l.to} className="hover-orange">{l.label}</Link></li>
      ))}
    </ul>
  </div>
);

const FooterContact = () => (
  <div>
    <h4 className="font-display text-[18px] tracking-wider mb-4 text-[#E8721C]">CONTACT</h4>
    <ul className="space-y-3 text-sm">
      <li className="flex gap-3 items-start"><Phone size={16} className="text-[#E8721C] mt-1"/><a className="tel-link" href={`tel:${COMPANY.phones[0].replace(/\s/g,'')}`}>{COMPANY.phones.join(" / ")}</a></li>
      <li className="flex gap-3 items-start"><Mail size={16} className="text-[#E8721C] mt-1"/><a className="hover-orange" href={`mailto:${COMPANY.emails[0]}`}>{COMPANY.emails[0]}</a></li>
      <li className="flex gap-3 items-start"><MapPin size={16} className="text-[#E8721C] mt-1"/><span>{COMPANY.address}</span></li>
    </ul>
    <div className="mt-5 flex gap-3" data-testid="social-icons">
      <a href={COMPANY.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-icon" data-testid="social-linkedin"><Linkedin size={18}/></a>
      <a href={COMPANY.socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon" data-testid="social-facebook"><Facebook size={18}/></a>
      <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="social-icon" data-testid="social-whatsapp"><MessageCircle size={18}/></a>
    </div>
  </div>
);

const Footer = () => (
  <footer className="bg-[#0A1628] text-white border-t-[4px] border-[#E8721C]" data-testid="footer">
    <div className="bg-[#1E2D40] py-3">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 text-center text-[11px] tracking-[.2em] text-[#8A96A3]">
        ACTIVE ACROSS AFRICA · OPEN TO GLOBAL ENQUIRIES
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <div className="font-display text-[26px]">CASSIE GEE<br/>INVESTMENTS CC</div>
        <p className="text-[#8A96A3] mt-3 text-sm leading-6">Quality. Delivery. 23 Years Strong.</p>
        <p className="text-[#8A96A3] mt-3 text-xs tracking-[.14em]">HEADQUARTERED IN PRETORIA · EST. 2003 · REG: {COMPANY.reg}</p>
      </div>
      <FooterNavColumn title="EXPLORE" links={NAV_LINKS.slice(0,4)} />
      <FooterNavColumn title="MORE" links={NAV_LINKS.slice(4)} />
      <FooterContact />
    </div>
    <div className="border-t border-white/10 py-5 bg-[#1E2D40]">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 flex flex-col md:flex-row justify-between items-center gap-2 text-[12px] text-[#8A96A3]">
        <span>© {new Date().getFullYear()} Cassie Gee Investments CC. All Rights Reserved.</span>
        <span>Reg: {COMPANY.reg}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
